import { OnInit, Component, Input } from '@angular/core';
import { StpConfigureService } from '../stp-configure.service';
import { PartListConnectorModel } from '../../../models/parts/part-list-connector.model';
import { ShowViewerArgs } from '../../../models/viewer/ShowViewerArgs.model';
import { ExtensionInterface } from '../../../models/viewer/ExtensionInterface.model';

@Component({
    selector: 'part-list',
    template: `<br>
<button (click)="clearInputs()" class="red-button" type="button" data-toggle="modal" data-target="#addConnectorPartListModal">Create</button>
<div class="table-wrapper">
    <div class="table-scroll">
        <table>
            <tr>
                <th *ngFor="let header of headers">{{header}}</th>
            </tr>
            <tr [class.highlighted]="checkTypeOfPartListElement(connector.variantId)" *ngFor="let connector of partListGridData,let row_no = index">
                <td>{{row_no + 1}}</td>
                <td>{{connector.articleNumber}}</td>
                <td>{{connector.description}}</td>
                <td>{{connector.unit}}</td>
                <td>{{connector.qty}}</td>
                <td>
                    <div [hidden]="!checkTypeOfPartListElement(connector.variantId)">
                            <i (click)="deletePartListElement(row_no)" class="material-icons cursor-pointer">delete</i>
                            <button (click)="setCurrentEdited(row_no)"  type="button" data-toggle="modal" data-target="#addConnectorPartListModal" class="material-icons cursor-pointer" style="background-color:transparent; border:none">edit</button>
                    </div>
                </td>
            </tr>
        </table>
    </div>
</div>


<!-- Create Modal -->
<div class="modal" id="addConnectorPartListModal">
    <div class="modal-dialog">
        <div class="modal-content">

            <!-- Modal Header -->
            <div class="modal-header">
                <div>Create part-list connector</div>
                <button type="button" class="close" data-dismiss="modal">&times;</button>
            </div>

            <!-- Modal body -->
            <div class="modal-body">
                <div class="display-flex row">
                    <div class="col-6"><span class="modal-label">Article no:</span></div>
                    <div class="col-6"><input type="number" [(ngModel)]="templateConnector.articleNumber"></div>
                </div>
                <div class="display-flex row">
                    <div class="col-6"><span class="modal-label">Description:</span></div>
                    <div class="col-6"><input type="text" [(ngModel)]="templateConnector.description"></div>
                </div>
                <div class="display-flex row">
                    <div class="col-6"><span class="modal-label">Unit:</span></div>
                    <div class="col-6">
                        <select name="unitSelect" [(ngModel)]="templateConnector.unit" class="selectHeight">
                            <option *ngFor="let unit of unitCollection" [ngValue]="unit">{{unit}}</option>
                        </select>
                    </div>
                </div>
                <div class="display-flex row">
                        <div class="col-6"><span class="modal-label">Qty:</span></div>
                        <div class="col-6"><input type="number" [(ngModel)]="templateConnector.qty"></div>
                </div>
            </div>

            <!-- Modal footer -->
            <div class="modal-footer">
                <button (click)="currentEdited = null" type="button" class="btn btn-danger red-button" data-dismiss="modal">Cancel</button>
                <button type="submit" class="btn btn-primary save-button" data-dismiss="modal" [disabled]="!isPartListConnectorValidate()" (click)="save()">Save</button>
            </div>
        </div>
    </div>
</div>
`,
    styles: [`table{font-family:arial,sans-serif;border-collapse:collapse;width:100%}td,th{border:1px solid #ddd;text-align:left;padding:8px}.pointer{cursor:pointer}.highlighted{background-color:#636475!important;color:#fff}`]
})
export class PartListComponent implements OnInit {
    @Input() args: ShowViewerArgs;

    private extensionInterface: ExtensionInterface;
    public headers = ['Pos', 'Article No', 'Description', 'Unit', 'Qty', 'Actions'];
    public partListGridData = [];
    public templateConnector = new PartListConnectorModel();
    public unitCollection = ['pc / m', 'pc', 'm'];
    public currentEdited = null;
    public currentViewerTypeId;

    constructor(private stpConfigureService: StpConfigureService) { }

    ngOnInit(): void {
        this.stpConfigureService.loadAllPartListConnectors(this.args.itemId).subscribe((res) => {
            this.partListGridData = res;
        }, (error: any) => {});
        this.setViewerTypeId();
    }

    save() {
        if (this.args.variantId !== null) {
            this.templateConnector.variantId = this.args.variantId;
        }
        if (this.currentEdited !== null) {
            this.updatePartListElement();
        }else {
            this.saveNewPartListConnector();
        }
    }

    saveNewPartListConnector() {
        this.templateConnector.connectorId = this.args.itemId;
        this.stpConfigureService.addNewPartListConnectorIntoDb(JSON.stringify(this.templateConnector)).subscribe((response) => {
            this.templateConnector._id = response;
            this.partListGridData.push(this.templateConnector);
            this.templateConnector = new PartListConnectorModel();
        });
    }

    deletePartListElement(elementIndex) {
        this.stpConfigureService.removePartListConnector(this.partListGridData[elementIndex]._id).subscribe((res) => {
        }, (error: any) => {});
        this.partListGridData.splice(elementIndex, 1);
    }

    isPartListConnectorValidate() {
        return this.templateConnector.articleNumber !== null && this.templateConnector.description.length > 2
        && this.templateConnector.qty !== null && this.templateConnector.unit.length > 0;
    }

    updatePartListElement() {
        Object.assign(this.partListGridData[this.currentEdited], this.templateConnector);
        this.stpConfigureService.updatePartListConnector(JSON.stringify
            (this.partListGridData[this.currentEdited])).subscribe((response) => {
                this.templateConnector = new PartListConnectorModel();
        });
        this.currentEdited = null;
    }

    setCurrentEdited(index) {
        this.currentEdited = index;
        Object.assign(this.templateConnector, this.partListGridData[index]);
    }

    clearInputs() {
        this.templateConnector = new PartListConnectorModel();
    }

    setViewerTypeId() {
        if (this.args.variantId === null) {
            this.currentViewerTypeId = this.args.itemId;
        }else {
            this.currentViewerTypeId = this.args.variantId;
        }
    }

    checkTypeOfPartListElement(variantId) {
        return (this.currentViewerTypeId === variantId && this.args.variantId !== null)
        || (!(variantId.length > 0) && this.args.variantId === null);
    }
}
